export const selectErrors = (state) => state.alerts.errors;
export const selectNews = (state) => state.alerts.news;
